export default "__VITE_ASSET__5682e511__"